import React, { Component } from "react";
import { connect } from "react-redux";
import { parse } from "query-string";

import {
  STATUS,
  getWebSurvey,
  setSubmittedBy,
  startSurveyDemo,
  startAppEmbedSurvey,
} from "state/modules/survey";
import { GET_WEB_SURVEY } from "state/modules/survey/types";
import { isLoading } from "state/modules/loading";

import { Background } from "components";

import screens from "screens";
import { hideLoader } from "utils";
import { logWebSurveyOpened, trackPage } from "utils/analytics/ga";

class WebSurvey extends Component {
  state = { loaded: false };

  componentDidMount = () => {
    const hash = window.location.hash.slice(2);
    const { slug, questionnaireId, customer } = parse(hash);
    if (slug && questionnaireId) {
      this.props.startSurveyDemo(slug, questionnaireId, customer);
      return;
    }

    const queryProps = parse(hash.split("?")[1]);
    const submittedBy = queryProps["sb"];
    if (submittedBy) {
      this.props.setSubmittedBy(submittedBy);
    }

    this.props.getWebSurvey(hash, queryProps);
    logWebSurveyOpened(hash);
    trackPage(hash);
  };

  screenMap = {
    [STATUS.EXPIRED]: screens.Expired,
    [STATUS.NOT_FOUND]: screens.NotFound,
    [STATUS.PENDING]: screens.Main,
    [STATUS.IN_PROGRESS]: screens.Question,
    [STATUS.RESULT]: screens.Result,
    [STATUS.SUBMITTING]: screens.Submit,
    [STATUS.SUBMITTED]: screens.ThankYou,
  };

  render = () => {
    const { loading, status } = this.props;

    if (loading) {
      return <Background />;
    }
    const Screen = this.screenMap[status];
    if (!this.state.loaded && Screen) {
      this.setState({ loaded: true });
      hideLoader();
    }
    if (Screen) {
      return <Screen navigation={this.props.navigation} />;
    }

    return <screens.NotFound />;
  };
}

const mapDispatchToProps = {
  getWebSurvey,
  startSurveyDemo,
  startAppEmbedSurvey,
  setSubmittedBy,
};

const mapStateToProps = state => {
  return {
    loading: isLoading(state, [GET_WEB_SURVEY]),
    status: state.survey.status,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WebSurvey);
